module.exports = __webpack_public_path__ + "img/img3.35277d65.jpg";